
import { defineComponent } from 'vue'
import { PostsRoot } from '@/composables/post/postList'
import usePostEdit from '@/composables/post/postEdit'
import PostEditTimer from '@/components/Post/SinglePost/PostEditTimer.vue'
import AButton from '@/components/Forms/AButton.vue'

export default defineComponent({
  name: 'PostEditButton',
  emits: ['toggle-edit-form'],
  components: { AButton, PostEditTimer },
  props: {
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    className: {
      type: String,
      default:
        'anz-link anz-flex anz-align-items-center anz-color-gray-600 anz-link-hover-underline',
    },
  },
  computed: {
    canEditComputed() {
      return this.canEdit && false === this.postRoot.post?.modified
    },
  },
  setup(props, { emit }) {
    return {
      ...usePostEdit(props.postRoot, emit),
    }
  },
})
